module.exports = __webpack_public_path__ + "static/monthly-bills-problem-56d6a178e5121eadc37608817cafd1f5.svg";